import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { getTermValue, TJsonQuery } from '../../../../packages/JsonQuery';
import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { selectJsonQuery } from '../../selectors/filters';
import { selectQueryStringWithQMark } from '../../selectors/queryString';
import { ITrackOfferActionsProps } from '../../types/tracking';

interface IUseTrackingPropsParams {
  offer: IDailyRentOfferForMobileSite;
  offerPosition: number;
  offersLength: number;
  reason: ITrackOfferActionsProps['reason'];
}

export const useTrackingProps = ({
  offer,
  offerPosition,
  offersLength,
  reason,
}: IUseTrackingPropsParams): ITrackOfferActionsProps => {
  const deviceType = useDeviceType();
  const jsonQuery = useSelector(selectJsonQuery);
  const queryString = useSelector(selectQueryStringWithQMark);

  const pageNumber = getTermValue('page')(jsonQuery as TJsonQuery) || 1;

  return React.useMemo(() => {
    // Хак для отелей, необходимый для быстрого запуска
    let gaLabel: string | null | undefined = offer.gaLabel;
    if (offer.isHotel) {
      gaLabel = gaLabel?.replace(new RegExp(/ga_obj_type=\d*/), 'ga_obj_type=11');
    }

    return {
      offerPosition,
      offerId: offer.id,
      gaLabel,
      offersLength,
      pageNumber,
      reason,
      isCianPartner: Boolean(offer.isCianPartner),
      isOnlineBooking: Boolean(offer.isOnlineBooking),
      partnerUrl: offer.isCianPartner ? offer.externalOfferUrl : undefined,
      jsonQuery,
      queryString,
      deviceType,
    };
  }, [
    offer.gaLabel,
    offer.isHotel,
    offer.id,
    offer.isCianPartner,
    offer.isOnlineBooking,
    offer.externalOfferUrl,
    offerPosition,
    offersLength,
    pageNumber,
    reason,
    jsonQuery,
    queryString,
    deviceType,
  ]);
};
